export default __webpack_public_path__ + "static/bg-5old-371e7781975c56f76e2c862f8cd32c6e.png";